import { primaryPrivateV2Api } from '@/lib/api-clients/rest-client';
import { NotificationChannelType } from '@/types';
import { useMutation } from '@tanstack/react-query';
import useNotifications from './get-notifications-settings';

export const MANDATORY_NOTIFICATION_TYPES = [
  'transaction.withdrawal.completed',
  'account.liquidation',
  'funded.profit.withdrawal.done',
  'funded.profit.withdrawal.approved',
];

type Body = {
  channelType: NotificationChannelType;
  destination: string;
};

async function createNotificationChannel(body: Body) {
  return primaryPrivateV2Api.post('/v2/notifications/channel', body);
}

export default function useCreateNotificationChannel() {
  const { refetch } = useNotifications();
  return useMutation({
    mutationFn: (body: Body) => createNotificationChannel(body),
    onSuccess: (_) => refetch(),
  });
}
